import React, {useEffect} from "react";
import {useNavigate} from 'react-router-dom';
import historyStore from "../../store/historyStore";
import HistoryInputCard from "../../components/HistoryInputCard";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import api from "../../utils/api";
import * as util from "../../utils/util";
import Stack from '@mui/material/Stack';
import ButtonBase from '@mui/material/ButtonBase';
import {styled} from '@mui/material/styles';
import historytopimg1 from "../../assets/images/history1.png";
import historytopimg2 from "../../assets/images/history2.png";

const HistoryHome = () => {
  const navigate = useNavigate();
  const storeData: any = historyStore();
  
  useEffect(() => {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      api.get(`app/api/v1/AP_002_001`).then(res => {
        const resData = res.data.result_data;
        const healthKey = Object.keys(resData.health);
        for (let item of healthKey) {
          setData(resData, item);
        }
      }).catch(function (error) {
        console.log(error)
      });
    }
  }, []);

  function setData(resData: any, item: any) {
    if (item === 'exercise') {
      storeData.setExerciseInfo('title', '오늘 소모 칼로리');
      storeData.setExerciseInfo('target', resData.target[item]);
      storeData.setExerciseInfo('kcal', resData.health[item]);
      storeData.setExerciseInfo('unitType', 'kcal');
      storeData.setExerciseInfo('infoText', resData.health_data[item]);
      storeData.setExerciseInfo('navi', () => { navigate('/history/burn'); });
    } else if (item === 'meal') {
      storeData.setMealInfo('title', '오늘 섭취 칼로리');
      storeData.setMealInfo('target', resData.target[item]);
      storeData.setMealInfo('kcal', resData.health[item]);
      storeData.setMealInfo('unitType', 'kcal');
      storeData.setMealInfo('infoText', resData.health_data[item]);
      storeData.setMealInfo('navi', () => { navigate('/history/eat'); });
    } else if (item === 'moisture') {
      storeData.setStepInfo('title', '오늘 수분 섭취');
      storeData.setStepInfo('target', resData.target[item]);
      storeData.setStepInfo('kcal', resData.health[item]);
      storeData.setStepInfo('unitType', 'cup');
      storeData.setStepInfo('infoText', resData.health_data[item]);
      storeData.setStepInfo('navi', () => { navigate('/history/drink'); });
    } else if (item === 'step') {
      storeData.setMoistureInfo('title', '오늘 걸음수');
      storeData.setMoistureInfo('target', resData.target[item]);
      storeData.setMoistureInfo('kcal', resData.health[item]);
      storeData.setMoistureInfo('unitType', 'step');
      storeData.setMoistureInfo('infoText', resData.health_data[item]);
      storeData.setMoistureInfo('navi', () => { navigate('/history/walking'); });
    }
  }

  const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  });

  // 새로고침 이미지 변경
  const ImageArr = [historytopimg1, historytopimg2,];
  const randomImg = Math.floor(Math.random() * ImageArr.length);
  const careTopImg = ImageArr[randomImg];



  return (
    <Box sx={{ p: 0, }}>

      <Box sx={{ bgcolor: '#d5f3dd', borderRadius: '0 0 40px 40px', display: 'flex', p: 0, minWidth: 320 }} >
        {/* logo */}
        <Box position={'fixed'} width={'100%'} bgcolor={'#d5f3dd'} zIndex={999}  maxWidth={'1200px'} >
          <Stack direction={'row'} >
            <Box>
              <ButtonBase sx={{ width: 180, height: 50, ml: 1 }}>
                <Img alt="Dual" src="/dual.png" />
              </ButtonBase>
            </Box>
          </Stack>
        </Box>

        <Grid container spacing={2} direction='row' sx={{ mt: 6 }}>

          <Grid container xs sx={{ pl: 2 }} direction='column' justifyContent='center' alignContent={'center'}>
            <Typography sx={{ fontSize: '2.2rem', color: '#3aa92e', fontWeight: 900, }}>
              건강관리
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#59b544', fontWeight: 500, }} gutterBottom>
              기록서비스
            </Typography>
          </Grid>
          <Grid sx={{ width: '45%', mr: 1, pt: 0, pl: 0 }} justifyContent='center' alignContent={'center'}>
            <Img alt="care" src={careTopImg} />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ p: 0, pb:12}}>

        <Box >
          <Typography sx={{ display: 'block', fontSize: '16px', color: '#444', p: '30px 0 0 0', textAlign: 'center' }}>
            <b>맞춤형 건강관리</b>를 위해<br /> <b>매일매일</b> 기록해 주세요.
          </Typography>
        </Box>

        {util.strNull(window.localStorage.userCusID) === '' ? (
          <Grid item sx={{ mt: 10 }}>
            <Box sx={BtnStyle}>
              <Button variant="contained" sx={BottomBtnStyle}
                onClick={() => navigate('../Login')}
              >
                로그인 후 이용해주세요.
              </Button>
            </Box>
          </Grid>
        ) : (
          <Grid item sx={{ display: 'flex', mt: 3, alignItems: 'center', justifyContent: 'center', flexDirection: 'column', pl: 2, pr: 2 }}>
            <Stack direction={'row'} spacing={2} sx={{ display: 'flex', mb: '20px', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <Box sx={{ width: '100%' }}>
                <HistoryInputCard healthInfo={storeData.mealInfo} />
              </Box>
              <Box sx={{ 
                width: '100%', 
                '& .MuiGauge-valueArc':{fill:'#ff5454'},
                '& .MuiLinearProgress-bar': {bgcolor:'#ff5454'}
                }}>
                <HistoryInputCard healthInfo={storeData.exerciseInfo} />
              </Box>
            </Stack>
            <Stack direction={'row'} spacing={2} sx={{ alignItems: 'center', justifyContent: 'center', width: '100%' }}>
              <Box sx={{
                width: '100%', 
                '& .MuiGauge-valueArc':{fill:'#33cccc'},
                '& .MuiLinearProgress-bar': {bgcolor:'#33cccc'}
                }}>
                <HistoryInputCard healthInfo={storeData.stepInfo} />
              </Box>
              <Box sx={{ 
                width: '100%', 
                '& .MuiGauge-valueArc':{fill:'#e029ff'},
                '& .MuiLinearProgress-bar': {bgcolor:'#e029ff'}
                }}>
                <HistoryInputCard healthInfo={storeData.moistureInfo} />
              </Box>
            </Stack>
          </Grid>
        )}

      </Box>
    </Box>
  );
}


const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: 3,
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};


export default HistoryHome;